export default __webpack_public_path__ + "static/media/Mordec Belt.d318fe0b.jpg";